import { projectPhotoPoint } from "./camera";
import type { ScenePhoto, Vector3 } from "./types";

const COLORS: Record<string, string> = {
  edge_0: "red",
  edge_1: "lime",
  edge_2: "blue",
  edge_3: "magenta",
};

export default function InfoPhoto({
  photo,
  edges,
}: {
  photo: ScenePhoto;
  edges: Record<string, Vector3[]>;
}) {
  return (
    <svg
      className="info-annotated-photo"
      viewBox={`0 0 ${photo.width} ${photo.height}`}
      role="img"
      aria-label={`${photo.title}: anotované body a hrany s výslednými křivkami fitu`}
    >
      <image href={photo.image} width={photo.width} height={photo.height} />
      {Object.entries(edges).map(([edge, points]) => {
        // Break the path at points behind the camera instead of joining across them.
        let drawing = false;
        const path = points
          .map((point) => {
            const projected = projectPhotoPoint(point, photo);
            if (!projected) {
              drawing = false;
              return "";
            }
            const command = drawing ? "L" : "M";
            drawing = true;
            return `${command}${projected[0]},${projected[1]}`;
          })
          .join(" ");
        return (
          <g
            key={edge}
            fill="none"
            strokeLinejoin="round"
            strokeLinecap="round"
          >
            <path
              d={path}
              stroke="#111"
              strokeWidth={5}
              vectorEffect="non-scaling-stroke"
            />
            <path
              d={path}
              stroke={COLORS[edge]}
              strokeWidth={2.5}
              vectorEffect="non-scaling-stroke"
            />
          </g>
        );
      })}
      {photo.annotations?.map((annotation, index) => (
        <g key={index} fill="none" stroke="white" strokeWidth={1.2}>
          {annotation.type === "physical_edge" && (
            <polyline
              points={annotation.points
                .map(([x, y]) => `${x * photo.width},${y * photo.height}`)
                .join(" ")}
              strokeDasharray="4 4"
              vectorEffect="non-scaling-stroke"
            />
          )}
          {annotation.points.map(([x, y], pointIndex) => (
            <circle
              key={pointIndex}
              cx={x * photo.width}
              cy={y * photo.height}
              r={
                photo.width * (annotation.type === "landmark" ? 0.006 : 0.0025)
              }
              stroke="white"
              vectorEffect="non-scaling-stroke"
            />
          ))}
        </g>
      ))}
    </svg>
  );
}
